import { Grid, Stack, Switch } from '@mui/material';
import { useState, useEffect } from 'react';
import { FormProvider, Controller, useForm } from 'react-hook-form';
import {
  getJobsDataDownloadSettings,
  IJobsDownloadTemplate,
  saveJobsDownloadTemplates,
} from 'wisestep-api';
import { WsButton, WsDialog } from 'wisestep-base';

import { DrawerFooter } from '../../../../../components/filters/components/AdvanceFilterFooterBar';
import FormSwitchLayout from '../../../../../features/careerPageSettings/components/formSwitchLayout';
import { defaultValues } from '../../../../../features/crmSettings/dataDownloadSettings/downloadSettings/helper';
import { success, warning } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';

import { JobFields, jobFieldsArray, jobsFieldsObj } from './Helper';
import JobsDownloadTemplates from './JobsDownloadTemplates';
import SaveTemplateDialog from './SaveTemplateDialog';

interface JobsDownloadProps {
  selectedFields: (v: string[]) => void;
  close(): void;
}
const JobsDownloadFields = ({ selectedFields, close }: JobsDownloadProps) => {
  const arr: string[] = [];
  const [open, setOpen] = useState<boolean>(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [fields, setFields] = useState(jobsFieldsObj);
  const [downloadSettingsData, setDownloadSettingsData] =
    useState<IJobsDownloadTemplate>(defaultValues);
  // const [tempalteData, setTemplateData] = useState<IJobsDownloadTemplate>();
  const methods = useForm({ defaultValues: fields });
  const { handleSubmit, setValue, control, reset, getValues } = methods;
  useEffect(() => {
    const fetchDataDownloadSettings = async () => {
      const getDataDownloadSettingsRes = await getJobsDataDownloadSettings();

      if (getDataDownloadSettingsRes?.data.allowedColumns.length > 0) {
        setDownloadSettingsData(getDataDownloadSettingsRes.data);
      } else {
        const tempData = getDataDownloadSettingsRes.data;
        tempData.allowedColumns = [
          'title',
          'jobCode',
          'locations',
          'description',
          'compensation',
          'jobType',
          'jobStatus',
          'createdOn',
          'CreatedBy',
          'skills',
          'companyName',
          'clientRecruiterName',
          'tags',
          'clientJobCode',
          'numberOfPositions',
          'accountManagerName',
        ];
        setDownloadSettingsData({ ...tempData });
      }
    };
    fetchDataDownloadSettings();
  }, []);
  useEffect(() => {
    const json = jobFieldsArray.reduce((json, value) => {
      json[value] = downloadSettingsData?.allowedColumns.indexOf(value) != -1;
      return json;
    }, jobsFieldsObj);
    if (json) setFields(json);
    reset(fields);
  }, [downloadSettingsData?.allowedColumns, fields, reset]);

  const saveTemplate = async (name: string) => {
    if (name) {
      const allowedColumns: string[] = [];
      const data = getValues();
      Object.keys(data).forEach((key) => {
        if (data[key]) {
          allowedColumns.push(key);
        }
      });
      try {
        const tempData: IJobsDownloadTemplate = {
          id: '',
          dataType: 'Jobs',
          name: name ?? '',
          recruiterId: '',
          workspaceId: '',
          allowedColumns: allowedColumns ?? [],
          isAdmin: false,
          recordsDownloadLimit: 2000,
          downloadCcEmail: '',
          isHidden: false,
          isFavorite: false,
        };
        await saveJobsDownloadTemplates(tempData);
        setNotification(success('Attributes settings applied successfully'));
      } catch (error) {
        setNotification(warning('Something Went Wrong , Please try again'));
      }
    } else {
      setNotification(warning('Template Name is Mandatory please Enter'));
    }
  };

  return (
    <FormProvider {...methods}>
      {/* <Grid item xs={12} display="flex" justifyContent="flex-end" mr={2}>
        
      </Grid> */}
      <Grid container spacing={2} p={1}>
        {fields &&
          jobFieldsArray.map((e: JobFields) => (
            <FormSwitchLayout key={e} label={e} gridValue={6} border="solid">
              <Controller
                name={e}
                control={control}
                render={(props) => (
                  <Switch
                    checked={props.field.value}
                    onChange={() => setValue(e, !props.field.value)}
                  />
                )}
              />
            </FormSwitchLayout>
          ))}
      </Grid>
      <DrawerFooter>
        <Stack p={1} columnGap={2} direction="row" justifyContent="space-between">
          <Grid item container columnGap={1}>
            <WsButton variant="contained" size="large" onClick={() => setOpen(true)}>
              Save Template
            </WsButton>
            <JobsDownloadTemplates
              selectedFields={(d) => {
                downloadSettingsData.allowedColumns = d.allowedColumns;
                setDownloadSettingsData({ ...downloadSettingsData });
              }}
            />
          </Grid>

          <Grid item container columnGap={1} justifyContent="flex-end">
            <WsButton variant="outlined" size="large" onClick={close}>
              cancel
            </WsButton>
            <WsButton
              variant="contained"
              size="large"
              onClick={handleSubmit((d) => {
                Object.entries(d).forEach(([key, value]) => {
                  if (value) arr.push(key);
                });
                selectedFields(arr);
              })}
            >
              Download
            </WsButton>
          </Grid>
        </Stack>
      </DrawerFooter>
      <WsDialog openDialog={open} onClose={() => setOpen(false)}>
        <SaveTemplateDialog
          getName={(name) => {
            saveTemplate(name);
            setOpen(false);
          }}
          close={() => setOpen(false)}
          templateName={''}
        />
      </WsDialog>
    </FormProvider>
  );
};
export default JobsDownloadFields;
